<template>
  <v-container fluid>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 sm6 md3>
        <v-container fluid grid-list-xs>
          <v-card class="rounded-card">
            <v-toolbar color="red" dark>
              <v-toolbar-title>Sign In</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 align-center justify-center text-xs-center>
                    <v-text-field v-model="email" label="Email"></v-text-field>
                    <v-text-field
                      v-model="password"
                      label="Password"
                    ></v-text-field>
                    <v-btn @click="login">Sign In</v-btn>
                    <div>
                      <p />
                      or Sign In with Google
                    </div>
                    <div>
                      <button class="social-button" @click="socialLogin">
                        <img
                          alt="Google Logo"
                          src="../assets/google-logo.png"
                        />
                      </button>
                    </div>
                    <div>
                      <p />
                      You don't have an account ? You can
                      <router-link to="/sign-up">create one</router-link>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
    <FloatingNav />
  </v-container>
</template>

<script>
import {
  getAuth,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import FloatingNav from "../components/FloatingNav.vue";

export default {
  name: "Login",
  components: { FloatingNav },
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    async saveUserRecord(user) {
      if (!user) return;
      try {
        const db = getFirestore();
        const userRef = doc(db, "users", user.uid);
        const creationTime =
          (user.metadata && user.metadata.creationTime) ||
          new Date().toISOString();
        const lastSignInTime =
          (user.metadata && user.metadata.lastSignInTime) || creationTime;

        await setDoc(
          userRef,
          {
            uid: user.uid,
            email: user.email || "",
            displayName: user.displayName || "",
            providerId:
              (user.providerData &&
                user.providerData[0] &&
                user.providerData[0].providerId) ||
              "password",
            createdAt: creationTime,
            lastLoginAt: lastSignInTime,
          },
          { merge: true }
        );
      } catch (_e) {
        // Non-fatal: failure to write user profile should not block login
      }
    },

    login() {
      const auth = getAuth();
      signInWithEmailAndPassword(auth, this.email, this.password)
        .then(async (userCredential) => {
          const user = userCredential && userCredential.user;
          if (user) {
            await this.saveUserRecord(user);
          }
          this.$router.replace("/");
        })
        .catch((err) => {
          alert("Oops. " + err.message);
        });
    },
    socialLogin() {
      const provider = new GoogleAuthProvider();
      const auth = getAuth();

      signInWithPopup(auth, provider)
        .then(async (result) => {
          const user = result && result.user;
          if (user) {
            await this.saveUserRecord(user);
          }
          this.$router.replace("/");
        })
        .catch((err) => {
          alert("Oops. " + err.message);
        });
    },
  },
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.login {
  margin-top: 40px;
}
input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}
button {
  margin-top: 20px;
  width: 10%;
  cursor: pointer;
}
p {
  margin-top: 40px;
  font-size: 13px;
}
p a {
  text-decoration: underline;
  cursor: pointer;
}
.social-button {
  width: 75px;
  background: white;
  padding: 10px;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  outline: 0;
  border: 0;
}
.social-button:active {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
.social-button img {
  width: 100%;
}
</style>
